module.exports = function getResource(label, vars = []) {
    const resources = {
        add: 'Ajouter',
        new: 'Nouveauté'
    };
    return resources[label];
};
